import { AdditionalViewToolsService } from '@addins/core/panel';
import { Injectable } from '@angular/core';
import { CacheService, CacheState } from '@services/cache/cache.service';
import { AppSettingProviderService, SagaSettingsService, StatusChangeViewPosition } from '@services/settings';
import { StatusViewService } from '@services/status/status-view/status-view.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { filter, first } from 'rxjs/operators';
import { StatusPanelTool } from '../../../schema/status-panel-tool';

@AddinExecute({
  name: 'Menu',
  description: 'Add a menu entry for open the status selector panel'
})
@Injectable()
export class StatusAccessMenuService extends Execute {
  private statusPanelTool = new StatusPanelTool();

  constructor(
    private statusView: StatusViewService,
    private additionalViewToolsService: AdditionalViewToolsService,
    private appSettingProvider: AppSettingProviderService,
    private sagaSettings: SagaSettingsService,
    private cache: CacheService
  ) {
    super();
  }

  init() {
    this.statusPanelTool.isVisible = false;
    this.statusView.statusPanelTool = this.statusPanelTool;
  }

  execute() {
    this.cache.state
      .pipe(
        filter(state => state === CacheState.ready),
        first()
      )
      .subscribe(() => {
        const statusPanelAlwaysOn: boolean = this.sagaSettings.getValue('SagaMobileWebClient.StatusChangeViewAlwaysOn');
        this.statusPanelTool.isVisible = !statusPanelAlwaysOn;
        this.statusPanelTool.button.setActive(statusPanelAlwaysOn);

        this.appSettingProvider.getStatusChangeViewPosition().subscribe(appSetting => {
          appSetting.$change.subscribe(newPosition => {
            const oldPosition: StatusChangeViewPosition = this.statusView.statusViewPosition;

            if (this.statusPanelTool.isVisible) {
              this.statusPanelTool.reset();
            }

            this.statusView.statusViewPosition = newPosition;

            if (newPosition == StatusChangeViewPosition.Bottom) {
              this.additionalViewToolsService.addTool(this.statusView.statusPanelTool);
            } else if (oldPosition == StatusChangeViewPosition.Bottom) {
              this.additionalViewToolsService.removeTool(this.statusView.statusPanelTool);
            }
          });
        });
      });
  }

  destroy() {}
}
